import { createAction } from 'redux-act'

import { VoucherResponse } from 'features/vouchers/types'

import { GiftCard } from '../../../checkout/types'

export const fetchCartStart = createAction('cart - fetch cart start')

export const fetchCartSuccess = createAction<any>('cart - fetch cart success')

export const fetchCartFail = createAction<any>('cart - fetch cart fail')

export const setPickUpInStoreData = createAction<any>('cart - set store data')

export const updateCartItemQuantityStart = createAction<any, any>(
  'cart - update cart item quantity start',
  (variantCode, quantity) => ({
    variantCode,
    quantity,
  }),
)

export const updateCartItemQuantitySuccess = createAction<any>(
  'cart - update cart item quantity success',
)

export const updateCartItemQuantityFail = createAction<any>('cart - update cart item quantity fail')

export const deleteCartItemStart = createAction<any>('cart - delete cart item start')

export const deleteCartItemSuccess = createAction<any>('cart - delete cart item success')

export const deleteCartItemFail = createAction<any>('cart - delete cart item fail')

export const moveToFavouriteStart = createAction<any>('cart - move to favourite start')

export const moveToFavouriteSuccess = createAction<any>('cart - move to favourite success')

export const moveToFavouriteFail = createAction<any, any, any>(
  'cart - move to_favourite_fail',
  ({ items, oosItems, hazmatItems }) => ({
    previousItemsState: items,
    previousOosItemsState: oosItems,
    previousHazmatItemsState: hazmatItems,
  }),
)

export const setCartItemPrices = createAction<VoucherResponse>('cart - set cart item prices')

export const oneClickCheckoutStart = createAction('one_click_checkout_start')

export const setOneClickCheckoutPaymentData = createAction<any>(
  'cart - set one click checkout payment data',
)

export const oneClickCheckoutSuccess = createAction('cart - one click checkout success')

export const oneClickCheckoutFail = createAction('cart - one click checkout fail')

export const fetchHiddenCartItems = createAction<any>('cart - fetch hidden cart items success')

export const deleteHiddenCartItem = createAction<any>('cart - delete hidden cart item ')

export const moveHiddenCartItem = createAction<any>('cart -  move hidden cart item to favourites')

export const addGiftCardStart = createAction('cart - Add gift cards start')
export const addGiftCardSuccess = createAction<GiftCard[]>('cart - Add gift cards success')
export const addGiftCardFail = createAction<{ message: string; isWarningMessage: boolean }>(
  'cart - Add gift cards fail',
)
export const setMaxGiftCardError = createAction<{
  message: string
  isWarningMessage: boolean
}>('cart - Set max gift card error')

export const removeGiftCardStart = createAction('cart - Remove gift cards start')
export const removeGiftCardSuccess = createAction<GiftCard[]>('cart - Remove gift cards success')
export const removeGiftCardFail = createAction('cart - Remove gift cards fail')
export const showMiddlePage = createAction('cart - Show middle page')
export const hideMiddlePage = createAction('cart - Hide middle page')
